"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var _AvatarColorHelper = require("./AvatarColorHelper");
var _Avatar2 = require("./Avatar.styled");
var _uuid = require("uuid");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function getColorIdValue(user) {
  var fl = "".concat(user.firstName, " ").concat(user.lastName);
  var id = '';
  var lenLimit = 24;
  while (id.length < 24) {
    id = "".concat(id).concat(fl);
  }
  return id.substr(0, lenLimit);
}

/**
 * User Avatar
 */
var Avatar = exports.Avatar = /*#__PURE__*/function (_Component) {
  function Avatar(props) {
    (0, _classCallCheck2["default"])(this, Avatar);
    return _callSuper(this, Avatar, [props]);
  }
  (0, _inherits2["default"])(Avatar, _Component);
  return (0, _createClass2["default"])(Avatar, [{
    key: "render",
    value: function render() {
      var _user$firstName, _user$lastName;
      var _this$props = this.props,
        user = _this$props.user,
        height = _this$props.height,
        width = _this$props.width,
        showColor = _this$props.showColor,
        hideTooltip = _this$props.hideTooltip,
        initialsFontSize = _this$props.initialsFontSize,
        backgroundColor = _this$props.backgroundColor;
      if (!user) return /*#__PURE__*/_react["default"].createElement("span", null);
      user.firstName = (_user$firstName = user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : '';
      user.lastName = (_user$lastName = user.lastName) !== null && _user$lastName !== void 0 ? _user$lastName : '';
      var userName = "".concat(user.firstName, " ").concat(user.lastName),
        type = user.type || null;
      var style;
      if (showColor) {
        var userRgb = (0, _AvatarColorHelper.getUserColor)(getColorIdValue(user));
        style = backgroundColor ? {
          backgroundColor: backgroundColor
        } : {
          backgroundColor: "rgb(".concat(userRgb.r, ",").concat(userRgb.g, ",").concat(userRgb.b, ")")
        };
      }
      var userInitials = "".concat(user.firstName.charAt(0).toUpperCase()).concat(user.lastName.charAt(0).toUpperCase());
      var altText = "Avatar for ".concat(user.firstName, " ").concat(user.lastName);
      altText = "".concat(altText, " in color background");
      var tipTargetId = "user_avatar_".concat((0, _uuid.v4)());
      var avatar = /*#__PURE__*/_react["default"].createElement(_Avatar2.AvatarWrapper, {
        className: "dd-privacy-mask",
        key: tipTargetId,
        style: _objectSpread(_objectSpread({}, style), {}, {
          width: width,
          height: height
        }),
        id: tipTargetId
      }, /*#__PURE__*/_react["default"].createElement(_Avatar2.ContentWrapper, {
        title: "".concat(altText),
        style: {
          width: width,
          height: height,
          fontSize: initialsFontSize
        },
        "data-testid": "user-avatar-content-wrapper"
      }, userInitials), type === 'editing' ? /*#__PURE__*/_react["default"].createElement(_Avatar2.UserEditing, {
        style: style
      }) : null);
      if (hideTooltip) return avatar;
      return [avatar, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
        className: "dd-privacy-mask",
        key: "".concat(tipTargetId, "-tooltip"),
        placement: "top",
        target: tipTargetId
      }, "".concat(userName, " ").concat(type === 'editing' ? 'is editing...' : ''))];
    }
  }]);
}(_react.Component);
(0, _defineProperty2["default"])(Avatar, "defaultProps", {
  hideTooltip: false,
  height: _Avatar2.DefaultAvatarSize,
  width: _Avatar2.DefaultAvatarSize,
  showColor: true,
  initialsFontSize: '16px'
});
Avatar.propTypes = {
  user: _propTypes.PropTypes.object,
  hideTooltip: _propTypes.PropTypes.bool,
  height: _propTypes.PropTypes.string,
  width: _propTypes.PropTypes.string,
  showColor: _propTypes.PropTypes.bool,
  initialsFontSize: _propTypes.PropTypes.string,
  backgroundColor: _propTypes.PropTypes.string
};